import I18n from '@js/modules/translations';

// Material Design icon per waypoint kind — the same icons as the mobile app (WAYPOINT_KIND_ICONS).
export const WAYPOINT_KIND_ICON_PATHS = {
    step: 'M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z',
    bivouac: 'M4,6C4,7.19 4.39,8.27 5,9A3,3 0 0,1 2,6A3,3 0 0,1 5,3C4.39,3.73 4,4.81 4,6M2,21V19H4.76L12,4.78L19.24,19H22V21H2M12,9.19L7,19H17L12,9.19Z',
    camp: 'M15.9,18.5L21.9,20.1L21.5,22L12.1,19.5L2.7,22L2.2,20.1L8.2,18.5L2.1,16.9L2.6,15L12,17.5L21.4,15L21.9,16.9L15.9,18.5M16.07,7.92C15.91,7.7 15.71,7.5 15.5,7.33C15.05,6.9 14.5,6.59 14.06,6.13C13,5.08 12.79,3.34 13.44,2C12.79,2.17 12.18,2.54 11.67,2.95C9.84,4.46 9.11,7.1 10,9.38C10,9.45 10.04,9.53 10.04,9.62C10.04,9.78 9.93,9.92 9.79,10C9.63,10.05 9.46,10 9.33,9.9C9.28,9.86 9.25,9.82 9.22,9.77C8.42,8.74 8.29,7.26 8.84,6.07C7.65,7.06 7,8.72 7.11,10.29C7.13,10.65 7.18,11 7.3,11.36C7.41,11.8 7.59,12.23 7.82,12.61C8.57,13.86 9.9,14.76 11.32,14.94C12.84,15.14 14.46,14.85 15.63,13.79C16.93,12.59 17.4,10.67 16.71,9L16.61,8.83C16.47,8.5 16.28,8.2 16.04,7.93L16.07,7.92M13.83,12.47C13.63,12.65 13.31,12.83 13.05,12.91C12.26,13.19 11.46,12.79 11,12.31C11.84,12.11 12.34,11.47 12.5,10.83C12.61,10.25 12.39,9.78 12.29,9.22C12.21,8.69 12.22,8.23 12.42,7.73C12.55,8 12.69,8.28 12.86,8.5C13.41,9.22 14.27,9.54 14.45,10.5C14.47,10.63 14.5,10.72 14.5,10.83C14.5,11.43 14.26,12.07 13.82,12.47',
    refuge: 'M12,3L20,9V21H15V14H9V21H4V9L12,3Z',
    shelter: 'M19 16H22L12 7L2 16H5L12 9.69L19 16M7 8.81V7H4V11.5L7 8.81Z',
    water: 'M12,20A6,6 0 0,1 6,14C6,10 12,3.25 12,3.25C12,3.25 18,10 18,14A6,6 0 0,1 12,20Z',
    supply: 'M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z',
    viewpoint: 'M11,6H13V13H11V6M9,20A1,1 0 0,1 8,21H5A1,1 0 0,1 4,20V15L6,6H10V13A1,1 0 0,1 9,14V20M10,5H7V3H10V5M15,20V14A1,1 0 0,1 14,13V6H18L20,15V20A1,1 0 0,1 19,21H16A1,1 0 0,1 15,20M14,5V3H17V5H14Z',
    pass: 'M15,3H17L22,5L17,7V10.17L22,21H2L8,13L11.5,17.7L15,10.17V3Z',
    summit: 'M12,2L1,21H23M12,6L19.53,19H4.47',
    parking: 'M13.2,11H10V7H13.2A2,2 0 0,1 15.2,9A2,2 0 0,1 13.2,11M13,3H6V21H10V15H13A6,6 0 0,0 19,9C19,5.68 16.31,3 13,3Z',
    danger: 'M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z'
};

const _kind = (poi) => {
    const kind = poi && poi.waypointKind;

    return kind && WAYPOINT_KIND_ICON_PATHS[kind] ? kind : 'step';
};

const NIGHT_KINDS = ['bivouac', 'camp', 'refuge'];

// Where the night is spent: a lodging kind, or any stop marked overnight.
export const isNightStop = (poi) => !!poi && (!!poi.overnight || NIGHT_KINDS.includes(poi.waypointKind));

// A plain step marked as a night stop reads as a bivouac (the mobile app counts overnight || bivouac as a night).
export const waypointIconPath = (poi) => {
    const kind = _kind(poi);

    return WAYPOINT_KIND_ICON_PATHS[kind === 'step' && poi && poi.overnight ? 'bivouac' : kind];
};

// Typed stop → its kind; plain step → its title, else "overnight", else the generic word.
export const waypointLabel = (poi) => {
    const kind = _kind(poi);

    if (kind !== 'step') {
        return I18n.t(`js.ride.form.pois.waypoint_kind.${kind}`);
    }

    if (poi && poi.title) {
        return poi.title;
    }

    if (poi && poi.overnight) {
        return I18n.t('js.ride.show.waypoints.overnight');
    }

    return I18n.t('js.ride.form.pois.waypoint_kind.step');
};

// A night on the trace: a stay of several hours across the PLACE's midnight, or starting in the small
// hours (a late arrival at the camp). A short aid-station stop at 23:55 is not a night, a long
// evening stop neither, and the clock is the place's, not the visitor's.
const NIGHT_MIN_SECONDS = 4 * 3600;
const NIGHT_LATE_ARRIVAL_HOUR = 5;

const _placeHour = (isoDate, timeZone) => {
    try {
        return Number(new Intl.DateTimeFormat('en-GB', {timeZone: timeZone || undefined, hour: '2-digit', hourCycle: 'h23'}).format(new Date(isoDate)));
    } catch {
        return new Date(isoDate).getHours();
    }
};

const _placeDate = (isoDate, timeZone) => {
    try {
        return new Intl.DateTimeFormat('en-CA', {timeZone: timeZone || undefined, year: 'numeric', month: '2-digit', day: '2-digit'})
            .format(new Date(isoDate));
    } catch (error) {
        return new Date(isoDate).toDateString();
    }
};

export const isNightStay = (arrivedAt, leftAt, timeZone) => {
    if (!arrivedAt || !leftAt) {
        return false;
    }

    const staySeconds = (new Date(leftAt) - new Date(arrivedAt)) / 1000;

    if (staySeconds < NIGHT_MIN_SECONDS) {
        return false;
    }

    return _placeDate(arrivedAt, timeZone) !== _placeDate(leftAt, timeZone) || _placeHour(arrivedAt, timeZone) < NIGHT_LATE_ARRIVAL_HOUR;
};

// pause_duration is stored in seconds (the mobile app's contract); the forms type minutes.
export const pauseMinutesToSeconds = (minutes) => Math.round((Number(minutes) || 0) * 60);

export const pauseSecondsToMinutes = (seconds) => Math.round((Number(seconds) || 0) / 60);
